module.exports = __webpack_public_path__ + "static/media/search.f123d7ab.svg";